import React, {useState} from 'react'
import $ from "jquery"
import SlidingPane from "react-sliding-pane";
import MagentoInfo from '../../MagentoInfo/MagentoInfo';

const Next = (props) => {
    const [state, setState] = useState({
        isPaneOpen: false,
    });

    const getAWSDetails = () => {
        var fieldsLength = $("#aws_setup .awsGroup").length
        var awsDetailsLength = props.awsDetails.length
        if(awsDetailsLength === 0){
            $(".aws_version-field").addClass("errorStateSelect")
        }else if(fieldsLength === props.awsDetails.length){
            setState({ isPaneOpen: true })
        }
    }
    return (
        <div className='row'>
            <div className="col-lg-12 float-right">
                <button type='button' id="awsSubmitnew" className="btn btn-primary btn-rounded waves-effect waves-light float-right awsnext" onClick={getAWSDetails}> Next </button>
            </div>
            <SlidingPane overlayClassName="some-custom-overlay-class" isOpen={state.isPaneOpen} onRequestClose={() => {setState({ isPaneOpen: false });}} title="Add Connector" subtitle="Select a Connector">
                <MagentoInfo 
                    egeQuestions={props.egeQuestions} 
                    awsDetails={props.awsDetails} 
                    name={props.name}
                    sourceName={props.sourceName}
                    targetName={props.targetName} 
                    connectorInfo={props.connectorInfo} 
                    instance = {props.instance}
                    id={props.id}
                    productTypeValue = {props.productTypeValue}
                    eventValue= { props.eventValue}
                    sourceVersion = {props.sourceVersion}
                    targetVersion ={props.targetVersion}
                    versionId ={props.versionId }
                />
            </SlidingPane>
        </div>
    )
}

export default Next
